import { useState } from "react";
import { useDemo } from "../zustand/DemoZustand";
import { Dokument, Kreuz, Liste, Ordner, PfeilRechts, Warnung } from "./Symbole";
import { ARTEN, loeseAuf, waehlbares } from "../hilfen/verknuepfung";

/*
  Die Liste der Verknüpfungen an einem Termin, samt Knopf zum Ergänzen.

  Ein Verweis, dem man nicht folgen kann, ist keiner — deshalb ist jeder
  Eintrag anklickbar und springt dorthin, worum es geht. Ausgenommen sind
  Verweise ins Leere: Die tragen ein Warnzeichen und sagen, dass es das nicht
  mehr gibt. Stillschweigend zu verschwinden wäre schlimmer, denn dann fehlte
  am Termin etwas, ohne dass es jemand merkt.
*/

const SYMBOLE = {
  top: Liste,
  vorlage: Dokument,
  aufgabe: Liste,
  datei: Ordner,
};

export default function Verknuepfungen({ verknuepfungen, aufAendern, oeffne, aufSchliessen }) {
  const { stammdaten, zustand, ich } = useDemo();
  const [offeneArt, setzeOffeneArt] = useState(null);

  const vorhanden = verknuepfungen || [];

  function entfernen(eintrag) {
    aufAendern(vorhanden.filter((v) => !(v.art === eintrag.art && v.id === eintrag.id)));
  }

  function ergaenzen(art, id) {
    if (vorhanden.some((v) => v.art === art && v.id === id)) return;
    aufAendern([...vorhanden, { art, id }]);
    setzeOffeneArt(null);
  }

  return (
    <>
      {vorhanden.length === 0 && <p className="klein leise">Nichts verknüpft.</p>}

      <div className="verknuepfungen">
        {vorhanden.map((eintrag) => {
          const aufgeloest = loeseAuf(eintrag, stammdaten, zustand);
          const Symbol = aufgeloest.fehlt ? Warnung : SYMBOLE[eintrag.art] || Dokument;

          return (
            <div
              key={`${eintrag.art}-${eintrag.id}`}
              className={`verknuepfung ${aufgeloest.fehlt ? "verknuepfung--fehlt" : ""}`}
            >
              <button
                className="verknuepfung__ziel"
                disabled={!aufgeloest.ziel}
                onClick={() => {
                  if (!aufgeloest.ziel) return;
                  if (aufSchliessen) aufSchliessen();
                  oeffne(aufgeloest.ziel[0], aufgeloest.ziel[1]);
                }}
              >
                <Symbol groesse={14} />
                <span className="verknuepfung__titel">{aufgeloest.titel}</span>
                {aufgeloest.ziel && <PfeilRechts groesse={13} />}
              </button>

              <button
                className="knopf knopf--schlicht"
                aria-label="Verknüpfung entfernen"
                onClick={() => entfernen(eintrag)}
              >
                <Kreuz groesse={14} />
              </button>
            </div>
          );
        })}
      </div>

      {/*
        Erst die Art wählen, dann den Eintrag. Eine einzige Liste aus
        Tagesordnungspunkten, Vorlagen, Aufgaben und Dateien wäre lang und
        unübersichtlich — und man weiß beim Verknüpfen ohnehin, was man
        sucht.
      */}
      <div className="wahl wahl--eng" style={{ marginTop: "var(--luft-2)" }}>
        {ARTEN.map(({ art, name }) => (
          <button
            key={art}
            className="wahl__knopf"
            aria-pressed={offeneArt === art}
            onClick={() => setzeOffeneArt(offeneArt === art ? null : art)}
          >
            + {name}
          </button>
        ))}
      </div>

      {offeneArt && (
        <div className="verknuepfung__auswahl">
          {waehlbares(offeneArt, stammdaten, zustand, ich.id).length === 0 ? (
            <p className="klein leise">Hier gibt es noch nichts zum Verknüpfen.</p>
          ) : (
            waehlbares(offeneArt, stammdaten, zustand, ich.id).map((eintrag) => (
              <button
                key={eintrag.id}
                className="verknuepfung__vorschlag"
                onClick={() => ergaenzen(offeneArt, eintrag.id)}
              >
                {eintrag.titel}
              </button>
            ))
          )}
        </div>
      )}
    </>
  );
}
